function setupEphemeralStorageInstance(state = {}, attachToSelf = false) {
    const storage = {
        getItem(key) {
            return state[key] === undefined ?
                null :
                state[key];
        },
        setItem(key, value) {
            state[key] = value;
        },
        clear() {
            state = {};
        },
        removeItem(key) {
            delete state[key];
        },
        key(index) {
            return Object.keys(state)[index];
        },
        get length() {
            return Object.keys(state).length;
        }
    };
    if (attachToSelf) {
        state = storage;
    }
    return storage;
}

function parseQueryString(string) {
    return decodeURIComponent(string).split('&')
        .filter(str => !!str)
        .map(str => str.split('='))
        .reduce((acc, pair) => ({
        ...acc,
        [pair[0]]: pair[1]
    }), {});
}
function stringifyQueryString(object) {
    return encodeURIComponent(Object.keys(object)
        .filter(key => key !== '' && object[key] !== undefined)
        .map(key => `${key}=${object[key]}`)
        .join('&'));
}
const urlStorage = {
    getItem(key) {
        const val = parseQueryString(location.hash)[key];
        return val === undefined ?
            null :
            val;
    },
    setItem(key, value) {
        const tmp = parseQueryString(location.hash);
        tmp[key] = value;
        location.hash = stringifyQueryString(tmp);
    },
    removeItem(key) {
        const tmp = parseQueryString(location.hash);
        delete tmp[key];
        location.hash = stringifyQueryString(tmp);
    }
};

var CACHE_TYPES;
(function (CACHE_TYPES) {
    /* Store the value in the hash of the URL */
    CACHE_TYPES[CACHE_TYPES["URL"] = 0] = "URL";
    /* Store the value in sessionStorage */
    CACHE_TYPES[CACHE_TYPES["SESSION"] = 1] = "SESSION";
    /* Store the value in localStorage */
    CACHE_TYPES[CACHE_TYPES["LOCALSTORAGE"] = 2] = "LOCALSTORAGE";
    /* Store the value in memory. Useful for classes that are frequently re-constructed (e.g. angular components) */
    CACHE_TYPES[CACHE_TYPES["EPHEMERAL"] = 3] = "EPHEMERAL";
})(CACHE_TYPES || (CACHE_TYPES = {}));
const ephemeralStorage = setupEphemeralStorageInstance();
function getStorage(cacheType) {
    let storage;
    switch (cacheType) {
        case CACHE_TYPES.URL:
            storage = urlStorage;
            break;
        case CACHE_TYPES.LOCALSTORAGE:
            storage = localStorage;
            break;
        case CACHE_TYPES.SESSION:
            storage = sessionStorage;
            break;
        case CACHE_TYPES.EPHEMERAL:
            storage = ephemeralStorage;
            break;
    }
    return storage;
}
// so that we are passing by reference on page load
const internalCacheMap = {};
const counter = {};
/**
 * Stores a value for re-use. DO NOT SET A DEFAULT
 *
 * @param cacheType Where to store the value
 * @param defaultValue The value to store if none exist
 * @param postInit Perform any mutations to the value on page load
 * @param duration How long should the value stay in the cache
 * @param customKey Override the key used to store in the cache
 */
function CachedAttr(cacheType, defaultValue, postInit, duration = Infinity, customKey) {
    const dec = function (target, attribute) {
        const isInitted = {};
        if (!postInit) {
            postInit = t => t;
        }
        const storage = getStorage(cacheType);
        let cacheKey;
        let durationKey;
        const initializer = (self) => {
            setKeys(self);
            const lastDate = +storage.getItem(durationKey);
            if ((Date.now() < (lastDate + duration)) || (duration === Infinity)) {
                internalCacheMap[cacheKey] = JSON.parse(storage.getItem(cacheKey));
                if (internalCacheMap[cacheKey] === null) {
                    internalCacheMap[cacheKey] = undefined;
                }
            }
            if ((typeof (defaultValue) !== 'undefined') &&
                (typeof (internalCacheMap[cacheKey]) === 'undefined')) {
                internalCacheMap[cacheKey] = defaultValue;
                storage.setItem(cacheKey, JSON.stringify(defaultValue));
                if (duration !== Infinity) {
                    storage.setItem(durationKey, `${Date.now()}`);
                }
            }
            isInitted[cacheKey] = true;
            internalCacheMap[cacheKey] = postInit(internalCacheMap[cacheKey]);
        };
        function setKeys(self) {
            let obtainedCustomKey = customKey;
            if (typeof obtainedCustomKey === 'function') {
                obtainedCustomKey = obtainedCustomKey(self);
            }
            counter[self.constructor.name + attribute] = counter[self.constructor.name + attribute] || 0;
            cacheKey = obtainedCustomKey ||
                cacheKey ||
                generateKey(self, attribute);
            durationKey = durationKey || `${cacheKey}-set-time`;
        }
        Object.defineProperty(target, attribute, {
            get() {
                setKeys(this);
                if (!isInitted[cacheKey]) {
                    initializer(this);
                }
                const { [cacheKey]: value } = internalCacheMap;
                return value;
            },
            set(value) {
                setKeys(this);
                if (!isInitted[cacheKey]) {
                    initializer(this);
                }
                internalCacheMap[cacheKey] = value;
                if (duration !== Infinity) {
                    storage.setItem(durationKey, `${Date.now()}`);
                }
                storage.setItem(cacheKey, JSON.stringify(value));
                if (value === null) {
                    storage.removeItem(cacheKey);
                    storage.removeItem(durationKey);
                }
            }
        });
    };
    return dec;
}
function generateKey(self, attribute, increment = true) {
    const count = increment ? ++counter[self.constructor.name + attribute] : counter[self.constructor.name + attribute];
    return `yc-cache-${count}-${self.constructor.name}-${attribute}`;
}

/**
 * Generated bundle index. Do not edit.
 */

export { CACHE_TYPES, CachedAttr, generateKey, getStorage, setupEphemeralStorageInstance, urlStorage };
